import { StyledLoadingButton } from '@jonni/styles/signup/stepsFooter';
import { graphql, navigate } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useId } from 'react';
import { useRecoilState } from 'recoil';
import SEO from 'src/components/Seo';
import StepHeader from 'src/components/Steps/StepHeader';
import { getRoutePath, Steps, stepsAtom } from 'src/recoil/steps/atoms';
import {
  StyledStepWrapper,
  WelcomeBusinessCardIcon,
  WelcomeContainer,
  WelcomeFooterText,
  WelcomeLockIcon,
  WelcomePrivacyIcon,
  WelcomeSubmitButtonContainer,
} from 'src/styles/signup/signupSteps';

const wrapperStyles: React.CSSProperties = { textAlign: 'center' };

const Welcome = () => {
  const [stepsState, setStepsState] = useRecoilState(stepsAtom);
  const { t } = useTranslation();
  const welcomeSubmitButtonContainerId = useId();

  const onSubmit = async () => {
    setStepsState({ ...stepsState, currentStep: Steps.AUTHENTICATION });
    await navigate(getRoutePath(Steps.AUTHENTICATION));
  };

  return (
    <>
      <SEO title={t('jonniName') + ' - ' + t('WELCOME.title')} />
      <StyledStepWrapper style={wrapperStyles}>
        <StepHeader title={t('welcome.title')} />
        <WelcomeContainer>
          <WelcomeBusinessCardIcon />
          <WelcomeFooterText>{t('welcome.content1')}</WelcomeFooterText>
          <WelcomePrivacyIcon />
          <WelcomeFooterText>{t('welcome.content2')}</WelcomeFooterText>
          <WelcomeLockIcon />
          <WelcomeFooterText>{t('welcome.content3')}</WelcomeFooterText>
        </WelcomeContainer>

        <WelcomeSubmitButtonContainer>
          <StyledLoadingButton
            id={`welcome-submit-button-container-${welcomeSubmitButtonContainerId}`}
            data-testid="welcome-next-button"
            onClick={onSubmit}
            color="primary"
            variant="contained">
            {t('welcome.btn')}
          </StyledLoadingButton>
        </WelcomeSubmitButtonContainer>
      </StyledStepWrapper>
    </>
  );
};

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { ns: { in: ["translation"] }, language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default Welcome;
